<abc-popup
  #notificationSettingsPopup
  class="notification-popup"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [width]="'50%'"
  [title]="aimsDataservice.res('manageNotification')"
  [showCloseButton]="!showLoader"
  [hideOnOutsideClick]="false"
  [resizeEnabled]="false"
>
  <div
    fxLayout="column"
    fxLayoutGap="20px"
    [style.filter]="showLoader ? 'blur(0.2rem)' : 'blur(0)'"
  >
    <div class="dx-popup-card">
      <div class="side-by-side-container">
        <div fxFlex="20">
          <div class="bloc-title">ID</div>
          <div class="designation-style">
            {{ notificationSettingsData?.Identifier }}
          </div>
        </div>
        <div class="designation-bloc">
          <div class="bloc-title">{{ notificationSettingsData?.Category }}</div>
          <div
            class="designation-style"
            [innerHTML]="notificationSettingsData?.Title"
          ></div>
        </div>
      </div>

      <div
        class="information-container"
        fxLayout="column"
        fxLayoutGap="5px"
        style="margin-bottom: 10px; margin-top: 10px"
      >
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div class="bloc-title">
            {{ aimsDataservice.res("notification-settings") }}
          </div>
        </div>
        <div
          class="setting-bloc"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <div>{{ notificationSettingsData?.Text }}</div>
          <div>
            @if (notificationSettingsData) {
              <abc-switch
                id="is-notification-allowed"
                [ngClass]="{
                  active: notificationSettingsData.IsActive,
                  inactive: !notificationSettingsData.IsActive,
                }"
                [(value)]="notificationSettingsData.IsActive"
              >
              </abc-switch>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="dx-popup-buttons" fxLayoutAlign="end end">
      <abc-button
        class="submit-button"
        icon="check"
        rtlEnabled="true"
        [text]="aimsDataservice.res('save')"
        (onClick)="turnOnOff()"
      ></abc-button>
    </div>
  </div>
</abc-popup>
